import { useState } from 'react';
import { GetVirtualAccountInfoQueryVariables, useGetVirtualAccountInfoQuery } from 'views/utils/graphql/graphql';

export const useTransferDistination = (initVariables: GetVirtualAccountInfoQueryVariables, pause: boolean) => {
  const [variables, setVariables] = useState<GetVirtualAccountInfoQueryVariables>();
  const [virtualAccounInfo, getVirtualAccountInfo] = useGetVirtualAccountInfoQuery({
    variables,
    requestPolicy: 'network-only',
    pause: pause,
  });
  return {
    virtualAccounInfo,
    getVirtualAccountInfo,
    setVariables,
  };
};
